const UMKD_SET_DIRECTION_TRAINIG = "UMKD_SET_DIRECTION_TRAINIG"
const UMKD_SET_SPECIALIZATION = "UMKD_SET_SPECIALIZATION"
const UMKD_SET_SUJECTS = "UMKD_SET_SUJECTS"
const UMKD_SET_FILES = "UMKD_SET_FILES"

const umkdTypes = {
    UMKD_SET_DIRECTION_TRAINIG, // Загрузка направлений подготовки
    UMKD_SET_SPECIALIZATION, // Загрузка специализаций
    UMKD_SET_SUJECTS, // Загрузка дисциплин
    UMKD_SET_FILES, // Загрузка файлов
}

export default umkdTypes